import React from "react";

const SectionBadge = ({ icon, text }) => {
  return (
    <div className="flex items-center gap-2 bg-white/30 border border-gray-200 px-4 py-2 rounded-full w-fit mx-auto shadow-sm">
      <span className="text-black text-lg font-bold">{icon}</span>
      <span className="text-black text-lg font-bold">{text}</span>
    </div>
  );
};

export default SectionBadge;